
import Component, { mixins } from 'vue-class-component'
import Mixin from '../../mixin'
import { Prop } from 'vue-property-decorator'
import { db } from '../../main'
import { URL_CLOUD_FUNCTIONS } from '@/firebase/init'
import axios from 'axios'

@Component
export default class DisableUser extends mixins(Mixin) {
  @Prop() user
  dialog_disable_user = false

  async updateUserStatus() {
    this.showNotification('loading', 'Procesando', 'Un momento por favor')
    const user = {
      disabled: true
    }

    console.log(user)
    try {
      const url = URL_CLOUD_FUNCTIONS + 'updateUser'
      const res = await axios.post(url, {
        uid: this.user.uid,
        user: user
      })
      console.log(res)
      this.showNotification('success', 'Éxito', 'Usuario deshabilitado')
      return res
    } catch (error) {
      this.showNotification(
        'fail',
        'Error',
        'Ocurrió un error al deshabilitar al usuario'
      )
      console.log(error)
      return null
    }
  }
}
